import styled from 'styled-components';

export const TableTitle = styled.div`
	font-size: 1rem;
	font-weight: 600;
`;
